import _ from 'underscore';
import $ from 'jquery';
import ContentWebDemoGridView from '../views/ContentWebDemoGridView';
import ProductThumbnailView from '../views/ContentProductThumbnailView';
import ContentGrid from './ContentGrid';

function splitRecommendations(recommendedIds) {
  const outArr = [];
  const obj = _.groupBy(recommendedIds, 'productType');
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      outArr.push(obj[key]);
    }
  }
  return outArr;
}

function reorderItems(items, orderedListArray) {
  const reorderedItems = [];
  const indexedItems = _.indexBy(items, item => item.id);
  let outerArrCnt = 0;
  let orderedListArrayLen = orderedListArray.length;
  while (outerArrCnt < orderedListArrayLen) {
    const innerArray = orderedListArray[outerArrCnt];
    if (innerArray.length > 0) {
      const reorderedItem = innerArray.splice(0, 1);
      if (indexedItems[(reorderedItem[0]).id]) {
        reorderedItems.push(indexedItems[(reorderedItem[0]).id]);
      }
      outerArrCnt++;
    } else {
      orderedListArray.splice(outerArrCnt, 1);
      orderedListArrayLen = orderedListArray.length;
    }
    outerArrCnt = (outerArrCnt === orderedListArrayLen) ? 0 : outerArrCnt;
  }
  return reorderedItems;
}

export default class ContentWebDemoGrid extends ContentGrid {
  createPanel({ items }) {
    const isRecByProductTypeEnabled = this.properties.prosCollectionDistProductTypeEnabled || false;
    if (isRecByProductTypeEnabled) {
      this.splitRecommendedIdsList = splitRecommendations([].concat(this.recommendedIdsList));
      // eslint-disable-next-line no-param-reassign
      items = reorderItems(items, this.splitRecommendedIdsList);
    }
    const model = this.getPanelData(items);

    // Set Title href
    this.getContentTargetUrl();
    model.set('content', this.content);

    $(this.config.element).addClass('pros-factory-grid pros-content-web-demo-grid');
    this.panel = new ContentWebDemoGridView({
      el: this.config.element,
      model,
      childView: ProductThumbnailView.extend({
        tagName: 'li',
      }),
      config: this.config,
    });
  }
}
